import { GenericAbortSignal } from "axios";
import * as urls from "../config/urls";
import { saveusersData } from "../redux/Slices/users";
import { store } from "../redux/store";
import { apiGet, apiPost, apiPostFormData, apiPut } from "../utils/utils";

const { dispatch } = store;

// Auth
export async function login(data: any) {
  const response: any = await apiPost(urls.LOGIN, data);
  if (response?.statusCode === 200 && response.data) {
    // Store all data in localStorage
    localStorage.setItem("authData", JSON.stringify(response.data));
  }
  return response;
}
export function logout() {
  return apiGet(urls.LOGOUT);
}

// Categories
export function listCategories(query = "") {
  return apiGet(urls.LIST_CATEGORIES + query);
}
export function addEditDeleteCategory(data: any) {
  return apiPost(urls.ADD_EDIT_DELETE_CATEGORY, data);
}

// Programs
export function listPrograms(query = "") {
  return apiGet(urls.LIST_PROGRAM + query);
}
export function addEditPrograms(data: any) {
  return apiPost(urls.ADD_EDIT_PROGRAMS, data);
}
export function listDetailsProgram(query = "") {
  return apiGet(urls.LIST_PROGRAM_DETAILS + query);
}
export function addEditProgramsDays(data: any) {
  return apiPut(urls.ADD_EDIT_PROGRAMS_DAYS, data);
}
export function sendProgramNotification(programId: string) {
  return apiPost(urls.SEND_PROGRAM_NOTIFICATION, { program_id: programId });
}
export function getAppleProductPrice(appleProductId: string) {
  return apiGet(`${urls.GET_APPLE_PRODUCT_PRICE}?apple_product_id=${encodeURIComponent(appleProductId)}`);
}

// podcasts
export function listPodcasts(query = "") {
  return apiGet(urls.LIST_PODCAST + query);
}
export function addEditPodcasts(data: any) {
  return apiPost(urls.ADD_EDIT_PODCASTS, data);
}
export function listDetailsPodcast(query = "") {
  return apiGet(urls.LIST_PODCAST_DETAILS + query);
}
// Meditation Guides
export function listMeditationGuides(query = "") {
  return apiGet(urls.LIST_MEDITATION_GUIDES + query);
}
export function addEditMeditationGuides(data: any) {
  return apiPost(urls.ADD_EDIT_MEDITATION_GUIDES, data);
}
// Magazines
export function listMagazines(query = "") {
  return apiGet(urls.LIST_MAGAZINES + query);
}
export function addEditMagazines(data: any) {
  return apiPost(urls.ADD_EDIT_MAGAZINES, data);
}
// Stories
export function listStory(query = "") {
  return apiGet(urls.LIST_STORY + query);
}
export function addEditStory(data: any) {
  return apiPost(urls.ADD_EDIT_STORY, data);
}

// Questions
export function listQuestions(query = "") {
  return apiGet(urls.LIST_QUESTIONS + query);
}
export function addEditQuestions(data: any) {
  return apiPost(urls.ADD_EDIT_QUESTIONS, data);
}
// Activities
export function listActivities(query = "") {
  return apiGet(urls.LIST_ACTIVITIES + query);
}
export function addEditActivities(data: any) {
  return apiPost(urls.ADD_EDIT_ACTIVITIES, data);
}
// Terms
export function listTerms() {
  return apiGet(urls.LIST_TERMS);
}
export function addEditTerms(data: any) {
  return apiPost(urls.ADD_EDIT_TERMS, data);
}

// Policy
export function listPolicy() {
  return apiGet(urls.LIST_POLICY);
}
export function addEditPolicy(data: any) {
  return apiPost(urls.ADD_EDIT_POLICY, data);
}

// banners
export function listBanners(query = "") {
  return apiGet(urls.LIST_BANNERS + query);
}

export function addEditBanners(data: any) {
  return apiPost(urls.ADD_EDIT_BANNERS, data);
}

// Users
export async function listUsers(query = "") {
  const res = (await apiGet(urls.LIST_USERS + query)) as {
    data?: any;
    [key: string]: any;
  };
  console.log(res, "resresresresresres");
  if (res?.data) {
    dispatch(saveusersData(res.data));
  }
  return res;
}

export function listUserDetails(query = "") {
  return apiGet(urls.LIST_USER_DETAILS + query);
}

export async function ImageUpload(data: FormData) {
  return apiPostFormData(urls.IMAGE_UPLOAD, data);
}
export async function deleteQuestion(data: any) {
  return apiPut(urls.DELETE_QUESTION, data);
}

export async function addEditABoutUS(data: any) {
  return apiPost(urls.ADD_EDIT_ABOUT_US, data);
}

export function listABoutUs(query = "") {
  return apiGet(urls.LIST_ABOUT_US + query);
}

export function listSupportContact(query = "") {
  console.log(urls.LIST_UPPORT_CONTACT + query, "dldldldlldll");
  return apiGet(urls.LIST_UPPORT_CONTACT + query);
}

// Promo Codes
export function listPromoCodes(query = "") {
  return apiGet(urls.LIST_PROMO_CODES + query);
}

export function addEditPromoCode(data: any) {
  return apiPost(urls.ADD_EDIT_PROMO_CODE, data);
}

export function deletePromoCode(id: string) {
  return apiPost(urls.DELETE_PROMO_CODE, { _id: id });
}

export async function deleteBlockUser(data: any) {
  return apiPut(urls.DELETE_BLOCK_USER, data);
}

// Analytics / Dashboard
export function getAnalytics(query = "") {
  return apiGet(urls.GET_ANALYTICS + query);
}

export function getPromoCodeAnalytics(query = "") {
  return apiGet(urls.GET_PROMO_CODE_ANALYTICS + query);
}

export function listPromoRedemptions(query = "") {
  return apiGet(urls.LIST_PROMO_REDEMPTIONS + query);
}

export function listAnalyticsUser(type: "SUBSCRIBED_USER" | "RECENT_USERS", skipNum?: number, extraQuery = "") {
  let query = `?type=${type}`;
  if (skipNum !== undefined) {
    query += `&skip_num=${skipNum}`;
  }
  if (extraQuery) {
    query += extraQuery;
  }
  return apiGet(urls.LIST_ANALYTICS_USER + query);
}

export function listTransactions(query = "") {
  return apiGet(urls.LIST_TRANSACTIONS + query);
}

// Version Control
export function getVersionControl(query = "") {
  return apiGet(urls.GET_VERSION_CONTROL + query);
}

export function addEditVersionControl(data: string) {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
  };
  return apiPost(urls.ADD_EDIT_VERSION_CONTROL, data, { headers });
}

// Push Campaign
export function listTags(query = "") {
  return apiGet(urls.LIST_TAGS + query);
}

export function listCampaignUsers(query = "") {
  return apiGet(urls.LIST_CAMPAIGN_USERS + query);
}

export interface PushCampaignFilters {
  audience_type?:
    | "all"
    | "specific"
    | "not_purchased_home_retreat"
    | "purchased_home_retreat"
    | "not_completed_quiz";
  skip_num?: number;
}

export function getUsersCount(filters: PushCampaignFilters) {
  return apiPost(urls.GET_USERS_COUNT, filters);
}

export function listPushCampaigns(query = "") {
  return apiGet(urls.LIST_PUSH_CAMPAIGNS + query);
}

export function pushCampaignScheduler(
  data: PushCampaignFilters & {
    campaign_name?: string;
    title: string;
    message: string;
    status: "draft" | "publish";
    campaign_type?: "instant" | "schedule";
    time_zone?: string;
    destination?: "home" | "home_retreat";
    program_id?: string;
    user_ids?: string[];
    date?: string;
    time?: string;
    date_time?: number;
  }
) {
  return apiPost(urls.PUSH_CAMPAIGN_SCHEDULER, data);
}

export function editPushCampaign(data: Record<string, any>) {
  return apiPost(urls.EDIT_PUSH_CAMPAIGN, data);
}

